import i18n from '../../i18n'
import { useLanguageStore } from '@/entities/language/model'

/**
 * BCP 47 mapping for the <html lang> attribute (WCAG 3.1.1 Level A).
 *
 * App locale keys (uzCYR/uzLAT/ruRUS) are kept for backend contract —
 * sent as the `lang` HTTP header in src/shared/api/request.ts:47.
 * Only the DOM attribute uses BCP 47, since screen readers and browser
 * pronunciation engines require it for correct voice/phonology selection.
 */
const BCP47: Record<string, string> = {
  uzCYR: 'uz-Cyrl',
  uzLAT: 'uz',
  ruRUS: 'ru',
}

export function initLanguageSync() {
  // Sync initial <html lang> from store on first call (app startup).
  const initialLang = useLanguageStore.getState().lang
  document.documentElement.lang = BCP47[initialLang] ?? 'en'

  useLanguageStore.subscribe((state, prevState) => {
    if (state.lang !== prevState.lang && i18n.language !== state.lang) {
      i18n.changeLanguage(state.lang).then(() => {
        // Sync <html lang> AFTER changeLanguage resolves (avoid race).
        document.documentElement.lang = BCP47[state.lang] ?? 'en'

        window.dispatchEvent(new Event('storage'))
        window.dispatchEvent(
          new CustomEvent('languagechange', { detail: { language: state.lang } }),
        )
      })
    }
  })
}
